export const HEADER_AND_MARGIN_HEIGHT = '84px';
